import React from 'react'

import Header from '../../common/components/Header'
import TextInput from '../../common/components/TextInput'
import TextArea from '../../common/components/TextArea'
import Button, { BUTTON_STYLES } from '../../common/components/Button'

import EditSegmentList from './EditSegmentList'

import { useEditClosure } from '../hooks'

import styles from './Form.module.css'

const EditClosureForm = () => {
  const [
    { agency, reason, notes, status, error },
    { edit, zoomTo, setNotes, markAsPending, reOpen, reclose },
  ] = useEditClosure()

  return (
    <div className={styles.container}>
      <Header>Edit Closure</Header>
      <div>
        <TextInput label="Closing Agency" value={agency} disabled={true} />
        <TextInput label="Reason" value={reason} disabled={true} />
        <TextArea
          label="Notes"
          placeholder="Enter any notes about the closure."
          rows={10}
          value={notes}
          onChange={setNotes}
        />
        <Button
          text={<i className="fas fa-crosshairs fa-2x"></i>}
          style={BUTTON_STYLES.NO_BORDER}
          onClick={zoomTo}
        />
        <EditSegmentList />
        {error && <div className={styles.errorMessage}>{error}</div>}
        <Button text="Save" style={BUTTON_STYLES.PRIMARY} onClick={edit} />
        <Button
          text="Re-Open"
          style={BUTTON_STYLES.SECONDARY}
          onClick={reOpen}
        />
        {status === 'PENDING' ? (
          <Button
            text="Re-Close"
            style={BUTTON_STYLES.SECONDARY}
            onClick={reclose}
          />
        ) : (
          <Button
            text="Mark as Pending"
            style={BUTTON_STYLES.SECONDARY}
            onClick={markAsPending}
          />
        )}
      </div>
    </div>
  )
}

export default EditClosureForm
